import React, { useState } from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import Avatar from "@material-ui/core/Avatar";
import { Badge } from "reactstrap";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import LongMenu from "../../menuNPaper/long/LongMenu";
import { formataCPFCNPJ } from "util/Auxiliary";
import CardBox from 'components/CardBox/index';
import { error, success, primary } from "configs/CustomColors";
import { isBlacklisted } from "util/blacklistUtil";

const ListEmpresas = ({ data, dispatch, company, setForm, alert }) => {

    return (
        <List>
            {data.map((item, index) => {
                return (
                    <CardBox
                        styleName="col-lg-12 col-md-6 col-12"
                        cardStyle="p-0"
                        heading={""}
                        headerOutside
                        key={index}
                    >
                        <ListItem button key={item.id} onClick={() => dispatch(item)}>
                            <ListItemAvatar>
                                <Avatar
                                    src={"data:image/png;base64," + item.logo_nfce}
                                    alt={item.razao_social}
                                />
                            </ListItemAvatar>
                            <ListItemText className="br-break" primary={item.razao_social} secondary={formataCPFCNPJ(item.cnpj)} />
                            {/* <ListItemText className="br-break" primary={"R$" + item.vr_valor} /> */}

                            <Badge className="mr-4 mt-2 text-uppercase"
                                style={{
                                    backgroundColor: isBlacklisted(item.cnpj) ? primary : (item.lo_ativo === 'S' ? success : error),
                                    color: "white"
                                }}
                                pill>{isBlacklisted(item.cnpj) ? "Migrado" : (item.lo_ativo === 'S' ? "Ativo" : "Inativo")}
                            </Badge>

                            {
                                company && <ListItemSecondaryAction>
                                    <LongMenu locale="list" setForm={setForm} company={company} value={item} alert={alert} />
                                </ListItemSecondaryAction>
                            }
                        </ListItem>
                    </CardBox>
                );
            })}
        </List>
    );
};

export default ListEmpresas;
